<template>
  <div>
    <div class="date-range ml-auto" v-if="!mobile">
      <span class="mr-2">Período</span>
      <div class="date-input" @click="openStartDate">
        <span class="date-placeholder">
          {{ startDate ? formatDate(startDate) : "De" }}
        </span>
        <img :src="getIcon('arrow')" />
        <input
            ref="startInput"
            type="date"
            v-model="startDate"
            @change="onStartChange"
        />
      </div>
      <div class="date-input ml-2" @click="openEndDate">
        <span class="date-placeholder">
          {{ endDate ? formatDate(endDate) : "Até" }}
        </span>
        <img :src="getIcon('arrow')" />
        <input
            ref="endInput"
            type="date"
            v-model="endDate"
            @change="onEndChange"
        />
      </div>
    </div>

    <div class="date-range d-flex flex-column m-0 p-0" v-else>
      <div
        class="date-input date-input-mobile h-25 mb-1"
        :class="(errorMessage && startDate) ? ' border-error' : ''"
        @click.stop="openStartDate"
      >
        <span class="date-placeholder">
          {{ startDate ? formatDate(startDate) : "De" }}
        </span>
        <i
          class="fa fa-trash text-error cursor-pointer"
          v-if="errorMessage && startDate"
          @click.stop="deletePeriodFrom"
        >
        </i>
        <input
          ref="startInput"
          type="date"
          v-model="startDate"
          @change="onStartChange"
        />
        <i
          class="fa fa-exclamation-circle text-error cursor-pointer"
          v-if="errorMessage && startDate"
          @click.stop="showMessageError"
        >
        </i>
      </div>
      <div
        class="date-input date-input-mobile h-25"
        :class="(errorMessage && endDate) ? ' border-error' : ''"
        @click.stop="openEndDate"
      >
        <span class="date-placeholder">
          {{ endDate ? formatDate(endDate) : "Até" }}
        </span>
        <i
          class="fa fa-trash text-error cursor-pointer"
          v-if="errorMessage && endDate"
          @click.stop="deletePeriodTo"
        >
        </i>
        <input
          ref="endInput"
          type="date"
          v-model="endDate"
          @change="onEndChange"
        />
        <i
          class="fa fa-exclamation-circle text-error cursor-pointer"
          v-if="errorMessage && endDate"
          @click.stop="showMessageError"
        >
        </i>

      </div>
    </div>

    <div v-if="errorMessage && !mobile && (startDate || endDate)" class="error-text">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import ArrowIcon from "@/assets/icons/arrow-down-icon.svg";

export default {
  name: "DashboardPeriodSelect",
  props: {
    mobile: {
      required: true,
    },
  },
  data() {
    return {
      errorMessage: "",
    };
  },
  computed: {
    ...mapState({
      startDate: (state) => state.buyer.dashboardFilter.period.from,
      endDate: (state) => state.buyer.dashboardFilter.period.to,
    })
  },
  methods: {
    ...mapActions("buyer", ["getDashboardCounts"]),
    ...mapMutations("buyer", ["setDashboardFilter", "setDashboardFilterFrom", "setDashboardFilterTo"]),

    openStartDate() {
      this.$refs.startInput.showPicker?.();
    },
    openEndDate() {
      this.$refs.endInput.showPicker?.();
    },

    onStartChange(e) {
      this.setDashboardFilterFrom(e.target.value);
      this.validateDates();
    },
    onEndChange(e) {
      this.setDashboardFilterTo(e.target.value);
      this.validateDates();
    },
    deletePeriodFrom() {
      this.setDashboardFilterFrom(null);
      this.validateDates();
    },
    deletePeriodTo() {
      this.setDashboardFilterTo(null);
      this.validateDates();
    },

    validateDates() {
      this.errorMessage = "";

      const parseLocalDate = (dateStr) => {
        const [year, month, day] = dateStr.split("-").map(Number);
        return new Date(year, month - 1, day);
      };

      if (this.startDate && this.endDate) {
        const start = parseLocalDate(this.startDate);
        const end = parseLocalDate(this.endDate);

        if (start > end) {
          this.errorMessage = "A data inicial não pode ser maior que a data final.";
          return;
        }

        const diffInMs = Math.abs(end - start);
        const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

        const startYear = start.getFullYear();
        const endYear = end.getFullYear();

        if (
            endYear - startYear > 1 ||
            (endYear - startYear === 1 &&
                (end.getMonth() > start.getMonth() ||
                    (end.getMonth() === start.getMonth() &&
                        end.getDate() > start.getDate())))
        ) {
          this.errorMessage = "O período selecionado não pode ser maior que 1 ano.";
          return;
        }

        if (diffInDays > 366) {
          this.errorMessage = "O período selecionado não pode ser maior que 1 ano.";
          return;
        }
      }

      if (this.startDate && !this.endDate) {
        const start = parseLocalDate(this.startDate);
        const today = new Date();
        const end = new Date(today.getFullYear(), today.getMonth(), today.getDate());

        if (start > end) {
          this.errorMessage = "A data inicial não pode ser maior que a data atual.";
          return;
        }
      }

      this.$store.dispatch("buyer/getDashboardCounts");
    },

    formatDate(date) {
      if (!date) return "";
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    getIcon(name) {
      const iconMap = {
        arrow: ArrowIcon,
      };
      return iconMap[name];
    },
    showMessageError() {
      alert(this.errorMessage)
    }
  },
};
</script>

<style scoped>
.date-range {
  display: flex;
  justify-content: center;
  align-items: center;
}

.date-range span {
  color: #797979;
  font-family: "Lexend Deca";
  font-size: 16px;
  font-weight: 400;
}

.date-input {
  position: relative;
  border-radius: 6px;
  border: 0.13rem solid #cfcfcf66;
  background: #fff;
  width: 148px;
  height: 35px;
  display: flex;
  align-items: center;
  padding-left: 8px;
  cursor: pointer;
}

.date-input-mobile {
  width: 100px;
  height: 20px;
}

.border-error {
  border: 0.13rem solid red;
}

.date-input .date-placeholder {
  font-family: "Lexend Deca";
  font-size: 14px;
  font-weight: 400;
  color: #797979;
}

.date-input img {
  position: absolute;
  top: 10px;
  right: 10px;
  pointer-events: none;
}

.date-input i.fa-exclamation-circle {
  position: absolute;
  top: 3px !important;
  left: 105%;
}

.date-input i.fa-trash {
  position: absolute;
  top: 3px !important;
  left: -18%;
}

.date-input input[type="date"] {
  position: absolute;
  inset: 0;
  opacity: 0;
  pointer-events: none;
}

.error-text {
  color: red;
  font-size: 14px;
  margin-top: 4px;
  font-family: "Lexend Deca";
}
</style>
